<template>
    <VDropdown
        class="notification_dropdown"
        :distance="6"
        :skidding="0"
        placement="bottom-end"
        :prevent-overflow="true"
        :overflow-padding="24"
        :positioning-disabled="isMobile"
        auto-boundary-max-size
        theme="notificationMenu"
        @apply-show="onShow()"
        @apply-hide="onHide()"
    >
        <div
            class="topbar_notification h-8 w-8 sm:h-[2.5rem] sm:w-[2.5rem] rounded-full item-center"
            :class="isDesktop.screenSize.value == 'xs' ? 'bg-gray-100' : 'bg-white dark:bg-black-500'"
        >
            <fa :icon="[iconType, icon]" class="bell-icon pl-2 pt-2 sm:pl-3 sm:pt-3" />
            <span class="topbar_notification__float">
                {{ notification }}
            </span>
        </div>
        <template #popper="{ hide }">
            <div class="notificationWrapper">
                <div
                    class="sm:hidden my-6 mt-6 mx-auto w-12 h-[5px] bg-black-900 rounded-full"
                ></div>
                <p
                    class="sm:hidden mx-auto text-center text-black-600 dark:text-white text-lg font-bold"
                >Notifications</p>
                <div
                    class="notificationUpper flex items-center justify-between px-4 py-4 sm:py-6 sm:fixed top-0 left-0 w-full bg-white dark:bg-black-500 z-10 h-20 rounded-t-lg border-b border-gray-200 dark:border-black-600"
                >
                    <AppButtonGroup
                        is-text-only
                        :tabs="notificationGroup"
                        @update-view="toggleMode"
                        class="!bg-gray-100 h-8 items-center !border !border-gray-100 dark:!bg-black-900 dark:!border-black-900 sm:!p-0 !p-[2px]"
                    />
                    <button class="text-xs text-blue-500 underline font-medium">Mark all as read</button>
                </div>
                <div class="notificationPanel">
                    <div :class="['tabs_content', currentTab === 'all' ? 'active' : '']">
                        <template v-for="notification in notificationsArray" :key="index">
                            <NotificationItem :notificationObj="notification" />
                        </template>
                    </div>
                    <div :class="['tabs_content', currentTab === 'unread' ? 'active' : '']">
                        <template v-for="unread in unreadArray" :key="index">
                            <NotificationItem :notificationObj="unread" />
                        </template>
                    </div>
                </div>
                <div
                    class="notificationDown flex items-center justify-between p-4 fixed bottom-0 left-0 w-full bg-white z-10 h-13 sm:rounded-b-lg border-t border-gray-200 dark:bg-black-500 dark:border-black-600"
                >
                    <button
                        class="text-xs font-medium flex items-center gap-1"
                        type="button"
                        @click="(openNotificationModal(), hide())"
                    >
                        <fa :icon="['fal', 'cog']" class="text-gray-300 text-lg"></fa>
                        <span class="text-gray-500">Manage notifications</span>
                    </button>
                </div>
            </div>
        </template>
    </VDropdown>
    <ManageNotificationsModal modalShowVal="notificationsModal" ref="notificationsModalRef" size="small" />
</template>

<script setup>
import { ref } from "vue";
import AppButtonGroup from "@/components/appComponents/AppButtonGroup.vue";
import AppButton from "@/components/AppButton.vue";
import AppDropdown from "@/components/dropdown/AppDropdown.vue";
import AppDropdownList from "@/components/dropdown/AppDropdownList.vue";
import ManageNotificationsModal from "@/components/topbar/ManageNotificationsModal.vue";
import NotificationItem from "@/components/topbar/NotificationItem.vue";
import { useScreenSize } from "@/composables/globals";
const isDesktop = useScreenSize();

const isMobile = ref(false);

const props = defineProps({
    notification: {
        type: String,
        default: "4",
    },
    iconType: {
        type: String,
        default: "fal",
    },
    icon: {
        type: String,
        default: "bell",
    },
});
const notificationGroup = ref([
    {
        emits: "all",
        state: true,
        text: "All",
    },
    {
        emits: "unread",
        state: false,
        text: "Unread",
    },
]);
const currentTab = ref("all");
const toggleMode = (newTab) => {
    console.log(newTab, "i am here");
    currentTab.value = newTab;
};
const notificationsArray = ref([
    {
        id: "1",
        invitedUser: "James P",
        title: "is now a member of your team!",
        type: "invite",
        notificationType: "action",
        about: "Access request",
        duration: "2hrs ago",
        acceptText: "Assign James to property",
        isRead: false,
    },
    {
        id: "2",
        invitedUser: "Andrew T",
        title: "has booked a viewing on 16 Oct 25 @ 15h30",
        property: "120 Liverpool street W1 7UI",
        type: "diary",
        confirmed: true,
        contacts: [
            {
                live: true,
                badge: "name_icon_b",
                first_name: "Contact",
                last_name: "name 2",
                email: "email@gmail.com",
                number: "0204 905 9884",
                newlead: false,
                star_icon: { active: true },
            },
        ],
        duration: "2hrs ago",
        isRead: true,
    },
    {
        id: "3",
        invitedUser: "Andrew T",
        title: "has booked a viewing on 16 Oct 25 @ 15h30",
        property: "120 Liverpool street W1 7UI",
        type: "diary",
        confirmed: false,
        contacts: [
            {
                live: true,
                badge: "name_icon_b",
                first_name: "Contact",
                last_name: "name 2",
                email: "email@gmail.com",
                number: "0204 905 9884",
                newlead: false,
                star_icon: { active: true },
            },
        ],
        duration: "2hrs ago",
        isRead: true,
    },
    {
        id: "4",
        invitedUser: "Rachel J",
        title: "has made a new offer £275,000",
        property: "120 Liverpool street W1 7UI",
        type: "offers",
        contacts: [
            {
                live: true,
                badge: "name_icon_r",
                first_name: "Contact",
                last_name: "name 2",
                email: "email@gmail.com",
                number: "0204 905 9884",
                newlead: false,
                star_icon: { active: true },
            },
        ],
        duration: "2hrs ago",
        isRead: true,
    },
    {
        id: "5",
        invitedUser: "Tim J",
        title: "has declined Rachel's offer of £250,000",
        property: "120 Liverpool street W1 7UI",
        type: "offers",
        contacts: [
            {
                live: true,
                badge: "name_icon_t",
                first_name: "Contact",
                last_name: "name 2",
                email: "email@gmail.com",
                number: "0204 905 9884",
                newlead: false,
                star_icon: { active: true },
            },
        ],
        duration: "2hrs ago",
        isRead: true,
    },
    {
        id: "6",
        invitedUser: "Rachel J",
        title: "has made a new offer £275,000",
        property: "120 Liverpool street W1 7UI",
        type: "offers",
        contacts: [
            {
                live: true,
                badge: "name_icon_r",
                first_name: "Contact",
                last_name: "name 2",
                email: "email@gmail.com",
                number: "0204 905 9884",
                newlead: false,
                star_icon: { active: true },
            },
        ],
        duration: "2hrs ago",
        isRead: true,
    },
    {
        id: "7",
        invitedUser: "Tim J",
        title: "has made a couter offer of £300,000",
        property: "120 Liverpool street W1 7UI",
        type: "offers",
        contacts: [
            {
                live: true,
                badge: "name_icon_s",
                first_name: "Contact",
                last_name: "name 2",
                email: "email@gmail.com",
                number: "0204 905 9884",
                newlead: false,
                star_icon: { active: true },
            },
        ],
        duration: "2hrs ago",
        isRead: true,
    },
    {
        id: "8",
        invitedUser: "Rachel J",
        title: "has made a new offer £200,000",
        property: "120 Liverpool street W1 7UI",
        type: "offers",
        contacts: [
            {
                live: true,
                badge: "name_icon_r",
                first_name: "Contact",
                last_name: "name 2",
                email: "email@gmail.com",
                number: "0204 905 9884",
                newlead: false,
                star_icon: { active: true },
            },
        ],
        duration: "2hrs ago",
        isRead: true,
    },
    {
        id: "9",
        invitedUser: "Andrew T",
        title: "has requested to be assigned to a property",
        property: "120 Liverpool street W1 7UI",
        type: "permission",
        confirmed: false,
        contacts: [
            {
                live: true,
                badge: "name_icon_b",
                first_name: "Contact",
                last_name: "name 2",
                email: "email@gmail.com",
                number: "0204 905 9884",
                newlead: false,
                star_icon: { active: true },
            },
        ],
        duration: "2hrs ago",
        isRead: true,
    },
    {
        id: "10",
        invitedUser: "Andrew T",
        title: "has requested to be assigned to a property",
        property: "120 Liverpool street W1 7UI",
        type: "permission",
        confirmed: true,
        contacts: [
            {
                live: true,
                badge: "name_icon_b",
                first_name: "Contact",
                last_name: "name 2",
                email: "email@gmail.com",
                number: "0204 905 9884",
                newlead: false,
                star_icon: { active: true },
            },
        ],
        duration: "2hrs ago",
        isRead: true,
    },
    {
        id: "11",
        invitedUser: "Tim M & Andrea T",
        title: "signed contract name.pdf",
        property: "120 Liverpool street W1 7UI",
        type: "document",
        confirmed: true,
        contacts: [
            {
                live: true,
                badge: "name_icon_b",
                first_name: "Contact",
                last_name: "name 2",
                email: "email@gmail.com",
                number: "0204 905 9884",
                newlead: false,
                star_icon: { active: true },
            },
            {
                live: true,
                badge: "name_icon_k",
                first_name: "Contact",
                last_name: "M 2",
                email: "email@gmail.com",
                number: "0204 905 9884",
                newlead: false,
                star_icon: { active: true },
            },
        ],
        duration: "2hrs ago",
        isRead: true,
    },
    {
        id: "12",
        invitedUser: "Tim M",
        title: "signed contract name.pdf",
        property: "120 Liverpool street W1 7UI",
        type: "document",
        confirmed: true,
        contacts: [
            {
                live: true,
                badge: "name_icon_m",
                first_name: "Contact",
                last_name: "name 2",
                email: "email@gmail.com",
                number: "0204 905 9884",
                newlead: false,
                star_icon: { active: true },
            },
        ],
        duration: "2hrs ago",
        isRead: true,
    },
    {
        id: "13",
        invitedUser: "James P",
        title: "is now a member of your team!",
        type: "invite",
        notificationType: "action",
        about: "Access request",
        duration: "2hrs ago",
        acceptText: "Assign James to property",
        isRead: false,
    },
    {
        id: "14",
        invitedUser: "Andrew T",
        title: "has booked a viewing on 16 Oct 25 @ 15h30",
        property: "120 Liverpool street W1 7UI",
        type: "diary",
        confirmed: true,
        contacts: [
            {
                live: true,
                badge: "name_icon_b",
                first_name: "Contact",
                last_name: "name 2",
                email: "email@gmail.com",
                number: "0204 905 9884",
                newlead: false,
                star_icon: { active: true },
            },
        ],
        duration: "2hrs ago",
        isRead: false,
    },
    {
        id: "15",
        invitedUser: "Andrew T",
        title: "has booked a viewing on 16 Oct 25 @ 15h30",
        property: "120 Liverpool street W1 7UI",
        type: "diary",
        confirmed: false,
        contacts: [
            {
                live: true,
                badge: "name_icon_b",
                first_name: "Contact",
                last_name: "name 2",
                email: "email@gmail.com",
                number: "0204 905 9884",
                newlead: false,
                star_icon: { active: true },
            },
        ],
        duration: "2hrs ago",
        isRead: false,
    },
    {
        id: "16",
        invitedUser: "Rachel J",
        title: "has made a new offer £275,000",
        property: "120 Liverpool street W1 7UI",
        type: "offers",
        contacts: [
            {
                live: true,
                badge: "name_icon_r",
                first_name: "Contact",
                last_name: "name 2",
                email: "email@gmail.com",
                number: "0204 905 9884",
                newlead: false,
                star_icon: { active: true },
            },
        ],
        duration: "2hrs ago",
        isRead: false,
    },
    {
        id: "17",
        invitedUser: "Tim J",
        title: "has declined Rachel's offer of £250,000",
        property: "120 Liverpool street W1 7UI",
        type: "offers",
        contacts: [
            {
                live: true,
                badge: "name_icon_t",
                first_name: "Contact",
                last_name: "name 2",
                email: "email@gmail.com",
                number: "0204 905 9884",
                newlead: false,
                star_icon: { active: true },
            },
        ],
        duration: "2hrs ago",
        isRead: false,
    },
    {
        id: "18",
        invitedUser: "Rachel J",
        title: "has made a new offer £275,000",
        property: "120 Liverpool street W1 7UI",
        type: "offers",
        contacts: [
            {
                live: true,
                badge: "name_icon_r",
                first_name: "Contact",
                last_name: "name 2",
                email: "email@gmail.com",
                number: "0204 905 9884",
                newlead: false,
                star_icon: { active: true },
            },
        ],
        duration: "2hrs ago",
        isRead: false,
    },
    {
        id: "19",
        invitedUser: "Tim J",
        title: "has made a couter offer of £300,000",
        property: "120 Liverpool street W1 7UI",
        type: "offers",
        contacts: [
            {
                live: true,
                badge: "name_icon_s",
                first_name: "Contact",
                last_name: "name 2",
                email: "email@gmail.com",
                number: "0204 905 9884",
                newlead: false,
                star_icon: { active: true },
            },
        ],
        duration: "2hrs ago",
        isRead: false,
    },
    {
        id: "20",
        invitedUser: "Rachel J",
        title: "has made a new offer £200,000",
        property: "120 Liverpool street W1 7UI",
        type: "offers",
        contacts: [
            {
                live: true,
                badge: "name_icon_r",
                first_name: "Contact",
                last_name: "name 2",
                email: "email@gmail.com",
                number: "0204 905 9884",
                newlead: false,
                star_icon: { active: true },
            },
        ],
        duration: "2hrs ago",
        isRead: false,
    },
    {
        id: "21",
        invitedUser: "Andrew T",
        title: "has requested to be assigned to a property",
        property: "120 Liverpool street W1 7UI",
        type: "permission",
        confirmed: false,
        contacts: [
            {
                live: true,
                badge: "name_icon_b",
                first_name: "Contact",
                last_name: "name 2",
                email: "email@gmail.com",
                number: "0204 905 9884",
                newlead: false,
                star_icon: { active: true },
            },
        ],
        duration: "2hrs ago",
        isRead: false,
    },
    {
        id: "22",
        invitedUser: "Andrew T",
        title: "has requested to be assigned to a property",
        property: "120 Liverpool street W1 7UI",
        type: "permission",
        confirmed: true,
        contacts: [
            {
                live: true,
                badge: "name_icon_b",
                first_name: "Contact",
                last_name: "name 2",
                email: "email@gmail.com",
                number: "0204 905 9884",
                newlead: false,
                star_icon: { active: true },
            },
        ],
        duration: "2hrs ago",
        isRead: false,
    },
    {
        id: "23",
        invitedUser: "Tim M & Andrea T",
        title: "signed contract name.pdf",
        property: "120 Liverpool street W1 7UI",
        type: "document",
        confirmed: true,
        contacts: [
            {
                live: true,
                badge: "name_icon_b",
                first_name: "Contact",
                last_name: "name 2",
                email: "email@gmail.com",
                number: "0204 905 9884",
                newlead: false,
                star_icon: { active: true },
            },
            {
                live: true,
                badge: "name_icon_k",
                first_name: "Contact",
                last_name: "M 2",
                email: "email@gmail.com",
                number: "0204 905 9884",
                newlead: false,
                star_icon: { active: true },
            },
        ],
        duration: "2hrs ago",
        isRead: false,
    },
    {
        id: "24",
        invitedUser: "Tim M",
        title: "signed contract name.pdf",
        property: "120 Liverpool street W1 7UI",
        type: "document",
        confirmed: true,
        contacts: [
            {
                live: true,
                badge: "name_icon_m",
                first_name: "Contact",
                last_name: "name 2",
                email: "email@gmail.com",
                number: "0204 905 9884",
                newlead: false,
                star_icon: { active: true },
            },
        ],
        duration: "2hrs ago",
        isRead: false,
    },
]);
const unreadArrayLength = ref("");
const unreadArray = ref([]);
const newUnreadArray = () => {
    console.log(unreadArray.value, "unreadArray");
    let isReadFilter = notificationsArray.value.filter((a) => {
        return a.isRead === false;
    });
    console.log(isReadFilter, "notificationsArray a");
    unreadArray.value = isReadFilter;
    unreadArrayLength.value = unreadArray.value.length;
    console.log(unreadArrayLength.value, "unreadArrayLength a");
    notificationGroup.value.forEach((tab) => {
        if (tab.emits === "unread" && !tab.count) {
            tab.count = unreadArrayLength.value;
            tab.text = `${tab.count} ${tab.text}`;
            // console.log(`${tab.count} notificationTabs.value[i]`);
        }
    });
};
const onShow = () => {
    newUnreadArray();
    if (isDesktop.screenSize.value === "xs") {
        isMobile.value = true;
        document.body.classList.add("no-scroll");
    }
};

const onHide = () => {
    if (isDesktop.screenSize.value === "xs") {
        isMobile.value = false;
        document.body.classList.remove("no-scroll");
    }
};
const readMethod = (notification) => {
    console.log(notification, "notification");
    notification.isRead = !notification.isRead;
};
const notificationsModalRef = ref();
const openNotificationModal = () => {
    notificationsModalRef.value.showModal("notificationsModal");
};
</script>

<style scoped>
.topbar_notification {
    @apply relative cursor-pointer inline-block;
}

.topbar_notification svg {
    @apply text-2xl text-gray-300 dark:text-black-900;
}

.topbar_notification__float {
    @apply w-4 h-4 rounded-full flex items-start justify-center font-semibold dark:text-black-900 bg-red-500 text-white absolute -top-[0.1rem] -right-[0.3rem] rtl:-left-1.5 text-xs;
}
.tabs_content {
    @apply overflow-y-auto sm:max-h-[calc(100vh-232px)] max-h-[calc(100vh-263px)] sm:pb-0 pb-[3.125rem];
}
.noticeBox {
    @apply relative;
}
.actBtns {
    @apply z-[2] absolute right-4 top-0;
}
.noticeBox:hover .top_opt {
    @apply opacity-100 transition-all;
}
.bell-icon {
    @apply !w-4 !h-4 dark:!text-gray-500;
}
/* .notificationWrapper {
    @apply sm:pt-[59px];
} */
.notificationPanel {
    @apply sm:mt-20 sm:mb-13;
}
:deep(.pipeline_toggler_btn) {
    @apply !text-gray-500 !text-sm !font-semibold dark:!text-gray-400;
}
:deep(.pipeline_toggler_btn.active) {
    @apply !text-black-500 !text-sm !font-semibold dark:!text-white;
}

</style>
